import img71 from './EquipoMedico/img71.jpg'
import img72 from './EquipoMedico/img72.jpg'
import img73 from './EquipoMedico/img73.jpg'
import { Footer } from './Footer'
import React, { Component } from 'react'
import { Card, Col, Row, Container } from 'react-bootstrap'
import { Navigation } from './Navigation'

export class Auxilios extends Component {
    render() {
        const productos = [
            { img: img71, title: "Maletines y mochilas" },
            { img: img72, title: "Accesorios" },
            { img: img73, title: "Otros accesorios" }
        ];

        return (
            <div>
                <Navigation />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1>Primeros Auxilios</h1>
                        </Col>
                    </Row>
                    <br />

                    {/* Malla de 3 columnas para equipos de respuesta rápida */}
                    <Row xs={1} md={2} lg={3} className="g-5 text-center">
                        {productos.map((item, idx) => (
                            <Col key={idx}>
                                <Card className="h-100 shadow border-0">
                                    <Card.Body className="p-2">
                                        <Card.Img 
                                            variant="top" 
                                            src={item.img} 
                                            style={{ 
                                                height: '450px', 
                                                objectFit: 'contain',
                                                padding: '15px'
                                            }} 
                                        />
                                    </Card.Body>
                                    <Card.Footer className="bg-white border-0">
                                        <Card.Title style={{ fontSize: '1.5rem', padding: '10px' }}>
                                            {item.title}
                                        </Card.Title>
                                    </Card.Footer>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}